import styled, { useTheme } from "styled-components";
import { Text } from "../components/Text";
import useChart from "../hooks/useChart";
import { FontWeight } from "../types";
import { FooterSection } from "../components/FooterSection";
import { StatsSection } from "../components/StatsSection";
import { ProductFilters } from "../components/ProductFilters";
import { MobileProductTable } from "./MobileProductTable";
import { DesktopProductTable } from "./DesktopProductTable";
import { BackgroundContainer, Container } from "../components/Container";
import { ProductCarousel } from "./ProductCarousel";
import useModal from "../hooks/useModal";

export const Home = () => {
  const { isMobile } = useTheme();
  const {
    data: {
      backgroundColor,
      header,
      instructions,
      useCustomProductFilters,
      showStats,
      stats,
      showFooter,
      footer,
    },
  } = useChart();
  const { open: isModalOpen } = useModal();

  return (
    <BackgroundContainer
      backgroundColor={backgroundColor?.hex}
      scrollEnabled={!isModalOpen}
    >
      <Container>
        {header && (
          <Header font={header.font} textColor={header.color}>
            {header.value}
          </Header>
        )}
        {instructions && instructions.value ? (
          <>
            <Instructions
              font={instructions.font}
              textColor={instructions.color}
            >
              {instructions.value}
            </Instructions>
            <ProductFilters />
          </>
        ) : (
          <StyledProductFilters />
        )}
        {!isMobile && useCustomProductFilters && <ProductCarousel />}
        {isMobile && <MobileProductTable />}
      </Container>
      {!isMobile && <DesktopProductTable />}
      {showStats && stats && (
        <StyledStatsSection
          statsSection={stats}
          lastSection={!showFooter || !footer}
        />
      )}
      {showFooter && footer && <FooterSection footerSection={footer} />}
    </BackgroundContainer>
  );
};

const Header = styled(Text)`
  &&& {
    font-weight: ${({ font: { weight = FontWeight.Black } = {} }) => weight};
    font-style: italic;
    font-size: ${({ theme }) =>
      theme.isMobile ? theme.getFontSize(30) : theme.getFontSize(48)}px;
    line-height: 1;
    max-width: ${({ theme }) => theme.getValue(600)}px;
    margin: 0 auto;
    text-align: center;
    color: ${({ theme, textColor }) => textColor?.hex || theme.colors.green2};
  }
`;

const Instructions = styled(Text)`
  &&& {
    font-size: ${({ theme }) =>
      theme.isMobile ? theme.getFontSize(16) : theme.getFontSize(20)}px;
    font-weight: 600;
    line-height: 1.25;
    max-width: ${({ theme }) => theme.getValue(1200)}px;
    margin: ${({ theme }) =>
      theme.isMobile
        ? `${theme.getValue(20)}px auto`
        : `${theme.getValue(36)}px auto`};
    text-align: center;
    color: ${({ theme, textColor }) => textColor?.hex || theme.colors.black};
  }
`;

const StyledProductFilters = styled(ProductFilters)`
  margin-top: ${({ theme }) =>
    theme.isMobile ? theme.getValue(20) : theme.getValue(80)}px;
`;

const StyledStatsSection = styled(StatsSection)<{ lastSection: boolean }>`
  padding-bottom: ${({ theme, lastSection }) =>
    lastSection ? theme.getValue(80) : theme.getValue(40)}px;
`;

export default Home;
